import React from 'react';
import { motion } from 'framer-motion';
import { Star, User } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María González',
    details: '42, Córdoba',
    text: 'Siempre se me morían los esquejes. Con esta guía logré multiplicar mis potus y mis suculentas sin perder ni una. Súper claro todo.'
  }, {
    name: 'Carlos Fernández',
    details: '35, Buenos Aires',
    text: 'Tengo un balcón chico y quería más plantas sin gastar. Ahora tengo el triple de plantas que antes. Vale cada peso.'
  }, {
    name: 'Laura Martínez',
    details: '28, Rosario',
    text: 'Estudié biología pero nunca me salían los esquejes en casa. Esta guía me mostró los errores que cometía. Ahora todo prende.'
  }, {
    name: 'Roberto Sánchez',
    details: '55, Mendoza',
    text: 'Jubilado con tiempo para la huerta. Gracias a la guía multipliqué mis aromáticas y ahora tengo para regalar. Muy práctica.'
  }, {
    name: 'Sofía Romero',
    details: '38, La Plata',
    text: 'Maestra con jardín en casa. Mis hijos ahora me ayudan a hacer esquejes. La guía es tan clara que hasta ellos entienden.'
  }];
  return <section className="py-16 md:py-24 bg-[#fafaf9]" data-id="element-157">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-158">
        <div className="text-center mb-16" data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-4" data-id="element-160">
            Lo que dicen quienes ya la usan
          </h2>
          <div className="flex justify-center gap-1 text-[#fbc02d]" data-id="element-161">
            {[1, 2, 3, 4, 5].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-162" />)}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-163">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-164">
              <div className="flex items-center gap-4 mb-4" data-id="element-165">
                <div className="w-12 h-12 bg-[#e8f5e9] rounded-full flex items-center justify-center text-[#4a7c2c]" data-id="element-166">
                  <User className="w-6 h-6" data-id="element-167" />
                </div>
                <div data-id="element-168">
                  <h4 className="font-bold text-[#1a1a1a]" data-id="element-169">{t.name}</h4>
                  <p className="text-sm text-[#666666]" data-id="element-170">{t.details}</p>
                </div>
              </div>
              <p className="text-[#4a7c2c] italic leading-relaxed" data-id="element-171">
                "{t.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}